// 21 províncias de Angola — Lei n.º 9/21 de 2021
export const provinciasAngola = [
  {
    designacao: 'Bengo',
    municipios: ['Ambriz', 'Bula Atumba', 'Dande', 'Dembos', 'Nambuangongo', 'Pango Aluquém'],
  },
  {
    designacao: 'Benguela',
    municipios: ['Balombo', 'Baía Farta', 'Benguela', 'Bocoio', 'Caimbambo', 'Catumbela', 'Chongorói', 'Cubal', 'Ganda', 'Lobito'],
  },
  {
    designacao: 'Bié',
    municipios: ['Andulo', 'Camacupa', 'Catabola', 'Chinguar', 'Chitembo', 'Cuemba', 'Cunhinga', 'Kuito', 'Nharea'],
  },
  {
    designacao: 'Cabinda',
    municipios: ['Belize', 'Buco-Zau', 'Cabinda', 'Cacongo'],
  },
  {
    designacao: 'Cuando Cubango',
    municipios: ['Cuchi', 'Cuito Cuanavale', 'Dirico', 'Longa', 'Mavinga', 'Menongue'],
  },
  {
    designacao: 'Cuando Norte',
    municipios: ['Calai', 'Cuangar', 'Lumbala Nguimbo', 'Nancova', 'Rivungo'],
  },
  {
    designacao: 'Cuanza Norte',
    municipios: ['Ambaca', 'Banga', 'Bolongongo', 'Cambambe', 'Cazengo', 'Golungo Alto', 'Gonguembo', 'Lucala', 'Ngonguembo', 'Samba Caju'],
  },
  {
    designacao: 'Cuanza Sul',
    municipios: ['Amboim', 'Cassongue', 'Cela', 'Conda', 'Ebo', 'Kibala', 'Kilenda', 'Libolo', 'Mussende', 'Porto Amboim', 'Quibala', 'Quilenda', 'Seles', 'Sumbe'],
  },
  {
    designacao: 'Cunene',
    municipios: ['Cahama', 'Cuanhama', 'Curoca', 'Cuvelai', 'Namacunde', 'Ombadja'],
  },
  {
    designacao: 'Huambo',
    municipios: ['Bailundo', 'Caála', 'Catchiungo', 'Chinjenje', 'Ecunha', 'Huambo', 'Londuimbali', 'Longonjo', 'Mungo', 'Tchikala-Tcholohanga', 'Ukuma'],
  },
  {
    designacao: 'Huíla',
    municipios: ['Caconda', 'Cacula', 'Caluquembe', 'Chiange', 'Chibia', 'Chicomba', 'Chipindo', 'Cuvango', 'Gambos', 'Humpata', 'Jamba', 'Lubango', 'Matala', 'Quilengues', 'Quipungo'],
  },
  {
    designacao: 'Icolo e Bengo',
    municipios: ['Calumbo', 'Catete', 'Icolo e Bengo', 'Quissama'],
  },
  {
    designacao: 'Luanda',
    municipios: ['Belas', 'Cacuaco', 'Cazenga', 'Luanda', 'Viana'],
  },
  {
    designacao: 'Lunda Norte',
    municipios: ['Cambulo', 'Capenda-Camulemba', 'Caungula', 'Chitato', 'Cuango', 'Cuílo', 'Lubalo', 'Lucapa', 'Xá-Muteba'],
  },
  {
    designacao: 'Lunda Sul',
    municipios: ['Cacolo', 'Dala', 'Muconda', 'Saurimo'],
  },
  {
    designacao: 'Malanje',
    municipios: ['Cacuso', 'Calandula', 'Cambundi-Catembo', 'Cangandala', 'Caombo', 'Cunda-Dia-Baze', 'Luquembo', 'Malanje', 'Marimba', 'Massango', 'Mucari', 'Quela', 'Quirima'],
  },
  {
    designacao: 'Moxico',
    municipios: ['Alto Zambeze', 'Léua', 'Luau', 'Luchazes', 'Lumeje', 'Moxico'],
  },
  {
    designacao: 'Moxico Leste',
    municipios: ['Bundas', 'Camanongue', 'Cazombo', 'Luacano'],
  },
  {
    designacao: 'Namibe',
    municipios: ['Bibala', 'Camucuio', 'Moçâmedes', 'Tômbwa', 'Virei'],
  },
  {
    designacao: 'Uíge',
    municipios: ['Aldeia Viçosa', 'Alto Cauale', 'Ambuíla', 'Bembe', 'Bungo', 'Cambamba', 'Damba', 'Maquela do Zombo', 'Milunga', 'Mucaba', 'Negage', 'Puri', 'Quimbele', 'Quitexe', 'Sanza Pombo', 'Songo', 'Uíge'],
  },
  {
    designacao: 'Zaire',
    municipios: ['Cuimba', 'M\'banza Kongo', 'Nóqui', 'Nzeto', 'Soyo', 'Tomboco'],
  },
];
